import React from "react";

const ErrorDisplay = ({ error }) => {
  if (!error) return null;

  // Check if the error is a user-facing message that shouldn't have the "API Error:" prefix
  const isUserFacingMessage =
    error.includes("reset") ||
    error.includes("No user found") ||
    error.includes("Password reset email sent");
  const prefix = isUserFacingMessage ? "" : "API Error: ";

  return (
    <div className="p-4 bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300 rounded-lg text-center">
      <p>
        <strong>{prefix}</strong> {error}
      </p>
    </div>
  );
};

export default ErrorDisplay;
